// Assets & liabilities catalog (Wealthfolio-style). Most assets are valued
// manually; precious metals are priced live (handled server-side).
import {
  Home, Car, Gem, Coins, CreditCard, Box,
} from "lucide-react";

const L = (fr, en) => ({ fr, en });

export const CURRENCIES = ["EUR", "USD", "GBP", "CHF", "CAD", "JPY"];
export const CURRENCY_LABELS = {
  EUR: "European Euro (EUR)", USD: "US Dollar (USD)", GBP: "British Pound (GBP)",
  CHF: "Swiss Franc (CHF)", CAD: "Canadian Dollar (CAD)", JPY: "Japanese Yen (JPY)",
};

// Step-1 picker cards. `kind: "liability"` routes to the liability form.
export const ASSET_KINDS = [
  { value: "property", kind: "asset", icon: Home, color: "#A3B18A",
    label: L("Bien immobilier", "Property"), sub: L("Immobilier & terrain", "Real estate & land") },
  { value: "vehicle", kind: "asset", icon: Car, color: "#60A5FA",
    label: L("Véhicule", "Vehicle"), sub: L("Voitures, bateaux & plus", "Cars, boats & more") },
  { value: "collectible", kind: "asset", icon: Gem, color: "#C084FC",
    label: L("Objet de collection", "Collectible"), sub: L("Art, montres & objets rares", "Art, watches & rare items") },
  { value: "precious_metal", kind: "asset", icon: Coins, color: "#F59E0B",
    label: L("Métal précieux", "Precious Metal"), sub: L("Or, argent & platine", "Gold, silver & platinum") },
  { value: "liability", kind: "liability", icon: CreditCard, color: "#F87171",
    label: L("Passif", "Liability"), sub: L("Prêts & dettes", "Loans & debt") },
  { value: "other", kind: "asset", icon: Box, color: "#94A3B8",
    label: L("Autre actif", "Other Asset"), sub: L("Actifs personnalisés", "Custom assets") },
];

export const LIABILITY_TYPES = [
  { value: "mortgage", label: L("Prêt immobilier", "Mortgage") },
  { value: "auto_loan", label: L("Prêt auto", "Auto Loan") },
  { value: "student_loan", label: L("Prêt étudiant", "Student Loan") },
  { value: "credit_card", label: L("Carte de crédit", "Credit Card") },
  { value: "personal_loan", label: L("Prêt personnel", "Personal Loan") },
  { value: "heloc", label: L("HELOC", "HELOC") },
  { value: "other", label: L("Autre", "Other") },
];

export const METALS = [
  { value: "gold", label: L("Or", "Gold") },
  { value: "silver", label: L("Argent", "Silver") },
  { value: "platinum", label: L("Platine", "Platinum") },
  { value: "palladium", label: L("Palladium", "Palladium") },
];

const ASSET_TYPE_META = {
  property: { icon: Home, color: "#A3B18A", label: L("Bien immobilier", "Property") },
  vehicle: { icon: Car, color: "#60A5FA", label: L("Véhicule", "Vehicle") },
  collectible: { icon: Gem, color: "#C084FC", label: L("Collection", "Collectible") },
  precious_metal: { icon: Coins, color: "#F59E0B", label: L("Métal précieux", "Precious Metal") },
  other: { icon: Box, color: "#94A3B8", label: L("Autre", "Other") },
};

export function assetMeta(item) {
  if (item.kind === "liability") return { icon: CreditCard, color: "#F87171" };
  return ASSET_TYPE_META[item.asset_type] || ASSET_TYPE_META.other;
}

export function lbl(o, lang) {
  return lang === "fr" ? o.fr : o.en;
}

export function assetTypeLabel(item, lang) {
  if (item.kind === "liability") {
    const lt = LIABILITY_TYPES.find((x) => x.value === item.liability_type);
    return lt ? lbl(lt.label, lang) : (lang === "fr" ? "Passif" : "Liability");
  }
  const m = ASSET_TYPE_META[item.asset_type] || ASSET_TYPE_META.other;
  return lbl(m.label, lang);
}
